var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48.00 48.00",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#000000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.096
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f90;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.2807,29.7009c1.112-.451,3.0916-1.0492,3.6872-.3272.6446.7814-.17,2.4769-.92,3.7942"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.7984,30.2234c1.7586,1.3965,6.9532,3.5343,12.4876,3.5343a17.0031,17.0031,0,0,0,10.1671-3.0789"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.204,21.9223a2.9773,2.9773,0,0,0,2.1769.5918h.5938a1.7516,1.7516,0,0,0,1.75-1.7535h0a1.7516,1.7516,0,0,0-1.75-1.7536H18.7871a1.7516,1.7516,0,0,1-1.75-1.7535h0a1.7517,1.7517,0,0,1,1.75-1.7535h.5938a2.9768,2.9768,0,0,1,2.1768.5918"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.669,19.8673a2.6468,2.6468,0,0,0,2.6468,2.6468h0a2.6469,2.6469,0,0,0,2.6469-2.6468V18.1468A2.6469,2.6469,0,0,0,28.3158,15.5h0a2.6468,2.6468,0,0,0-2.6468,2.6468"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 25.669,
    y1: 15.5,
    x2: 25.669,
    y2: 26.0873
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSp);
export default __webpack_public_path__ + "static/media/sp.776bc8342168f8f632ba410b48b0ad8a.svg";
export { ForwardRef as ReactComponent };